import {React, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import {Delete} from '@mui/icons-material';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';
import { formatDate } from '../../common/constants';

let fetch_id = 0;
let delete_id = 0;
export default function DeductionComponentsTable(props) {

  const [openPopup, setOpenPopup] = useState(false);
  const [deductionComponents, setDeductionComponents] = useState([]);
  const navigate = useNavigate();
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''});

  const dispatch = useDispatch();
  const updateEmpDeductionComponents = useSelector(state => state.updateEmpDeductionComponents);

  async function getDeductionComponents(){
    let API_URL = "";
    if(props.fetch_id !== 9999) {
      API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/view-deduction-components/` + props.fetch_id;
    }else {
      API_URL = `${process.env.REACT_APP_API_BASE_URL}/employee-master/view-deduction-components/` + props.employeeID;
    }
    try {
      const deductionComponents = await axios.get(API_URL);
      setDeductionComponents(deductionComponents.data);
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
    }
  }
  
  useEffect(()=>{
    getDeductionComponents();
  }, []);

  useEffect(()=>{
    if(updateEmpDeductionComponents){
      getDeductionComponents();
      dispatch(updateTableActions.stopUpdateEmpDeductionComponents());
    }
  }, [updateEmpDeductionComponents]);

  const handleDelete = async (delete_id) => {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      });
      try {
        const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/employee-master/delete-deduction/` + delete_id);
        
        if(res.status === 200) {
          getDeductionComponents();
          setNotify({
            isOpen: true,
            message: 'Successfully Deleted!',
            type: 'error'
          });
        }
        dispatch(updateTableActions.startUpdateEmpDeductionComponents());
      } catch (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
  }

  return (
    <div>

    <table class="table">
        <thead class="table-dark">
          <tr>
           
            <th scope="col">Deduction Type</th>
            <th scope="col">Effective Date</th>
            <th scope="col">Amount</th>
            <th scope="col">Month</th>
            <th scope="col">Year</th>
            <th class="table-dark"></th>
          </tr>
        </thead>
        <tbody>
          {deductionComponents.map((deductionComponent , i) => {
            return (
              <>
                <tr>
                  
                  <td>{deductionComponent.deductionTypeName}</td>
                  <td>{formatDate(deductionComponent.deduction_date.split('T')[0])}</td>
                  <td>{deductionComponent.amount}</td>
                  <td>{deductionComponent.deduction_month}</td>
                  <td>{deductionComponent.deduction_year}</td>

                  <td><button type="button" class="btn btn-outline-danger btn-sm" onClick={() => setConfirmDialog({
                      isOpen: true,
                      title: 'Are you sure to delete this record?',
                      subTitle: "You can't undo this operation",
                      onConfirm: () => {handleDelete(delete_id=deductionComponent.deduction_component_id)}
                      }) } 
                   
                  > <Delete/> Delete </button></td>
                </tr>
            </>
          )
        })}

        </tbody>
      </table>
      <Notification
          notify={notify}
          setNotify={setNotify} />
      <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog} />
    </div>

  );
}
